//TOP PARENT ID = 211

const hierarchy = [
  {
    'id': 211,
    'parentId': 179,
    'name': 'Golden Corral Corporation',
    'typeId': 3,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1043,
    'parentId': 1430,
    'name': 'Henderson, NC 0618',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1047,
    'parentId': 1430,
    'name': 'Kinston, NC 0628',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1048,
    'parentId': 211,
    'name': 'GC Corp',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1046,
    'parentId': 1428,
    'name': 'Wilson, NC 0990',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1042,
    'parentId': 1430,
    'name': 'Morehead City, NC 0613',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1356,
    'parentId': 1433,
    'name': 'Farmington, NM 0609',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1380,
    'parentId': 1428,
    'name': 'Garland, TX 0947',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1388,
    'parentId': 1433,
    'name': 'Albuquerque, NM 0919',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1393,
    'parentId': 1436,
    'name': 'Houston, TX 0974',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1395,
    'parentId': 1430,
    'name': 'Huntsville, AL 0987',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1396,
    'parentId': 1431,
    'name': 'Alexandria, LA 0980',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1397,
    'parentId': 1428,
    'name': 'Arlington, TX 0976',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1404,
    'parentId': 1435,
    'name': 'Morgantown, WV 0971',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1405,
    'parentId': 1428,
    'name': 'Florence, AL 0998',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1353,
    'parentId': 1433,
    'name': 'Midwest City, OK 0550',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1361,
    'parentId': 1431,
    'name': 'Mobile, AL 0644',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1391,
    'parentId': 1435,
    'name': 'Monroeville, PA 0970',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1406,
    'parentId': 1428,
    'name': 'Decatur, AL 0997',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1355,
    'parentId': 1428,
    'name': 'Orange Park, FL 0607',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1363,
    'parentId': 1433,
    'name': 'Enid, Ok 0636',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1371,
    'parentId': 1431,
    'name': 'Layfayette, LA 0906',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1407,
    'parentId': 1428,
    'name': 'Houston, TX 0993',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1428,
    'parentId': 1048,
    'name': 'District 10',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1429,
    'parentId': 1048,
    'name': 'District 11',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1430,
    'parentId': 1048,
    'name': 'District 12',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1431,
    'parentId': 1048,
    'name': 'District 13',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1432,
    'parentId': 1048,
    'name': 'District 14',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1377,
    'parentId': 1433,
    'name': 'Albuquerque, NM 0936',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1408,
    'parentId': 1428,
    'name': 'Horn Lake, MS 0102',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1411,
    'parentId': 1428,
    'name': 'Jacksonville, FL 0600',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1433,
    'parentId': 1048,
    'name': 'District 15',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1434,
    'parentId': 1048,
    'name': 'District 16',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1435,
    'parentId': 1048,
    'name': 'District 17',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1436,
    'parentId': 1048,
    'name': 'District 18',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 2127,
    'parentId': 1431,
    'name': 'West Monroe, LA 0103',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 22535,
    'parentId': 1428,
    'name': 'GC-973-FINDLAY, OH',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 23161,
    'parentId': 1428,
    'name': 'GC-646-BROOKSVILLE, FL',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24180,
    'parentId': 1432,
    'name': 'Newnan, GA 0861',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24170,
    'parentId': 1432,
    'name': 'Laredo, TX 0713',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24080,
    'parentId': 1432,
    'name': 'Council Bluffs, IA 0649',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24224,
    'parentId': 1432,
    'name': 'Aurora, CO  0793',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24397,
    'parentId': 1432,
    'name': 'Alpharetta, GA 2445',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24475,
    'parentId': 1432,
    'name': 'Greenville, SC 2549',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24280,
    'parentId': 1432,
    'name': 'Lake Havasu City, AZ  2566',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 24648,
    'parentId': 1432,
    'name': 'MCDONOUGH, GA 2483',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24440,
    'parentId': 1432,
    'name': 'Canton, OH 0955',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24672,
    'parentId': 1432,
    'name': 'GC-2498 Hanover, MD 2498',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24953,
    'parentId': 1432,
    'name': 'Hagerstown, MD 2600',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24675,
    'parentId': 1432,
    'name': 'O\'Fallen, MO 2624',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24922,
    'parentId': 1432,
    'name': 'Cumming, GA 2585',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24938,
    'parentId': 1432,
    'name': 'Saint Louis, MO  2611',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24919,
    'parentId': 1432,
    'name': 'Springfield, MO  2532',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24926,
    'parentId': 1432,
    'name': 'Virginia Beach, VA  2540',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24945,
    'parentId': 1432,
    'name': 'N. Charleston, SC 2599',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24970,
    'parentId': 1432,
    'name': 'Marietta, GA 2671',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1703,
    'parentId': 1435,
    'name': 'Owensboro, KY 0101',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24658,
    'parentId': 1432,
    'name': 'Largo, MD 2486',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 26626,
    'parentId': 1432,
    'name': 'Wyncote, PA  2710 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 26100,
    'parentId': 1434,
    'name': 'SCHERERVILLE, IN 2541 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 213,
    'parentId': 1430,
    'name': 'Raleigh, NC 0935',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 27073,
    'parentId': 1434,
    'name': 'Bloomingdale, IL  2707',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1365,
    'parentId': 1431,
    'name': 'Pensacola, FL 0668',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 26310,
    'parentId': 1434,
    'name': 'ARLINGTON HEIGHTS,   2703',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1362,
    'parentId': 1429,
    'name': 'Destin, FL 0647',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1409,
    'parentId': 1431,
    'name': 'Baton Rouge, LA 0996',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1351,
    'parentId': 1433,
    'name': 'Roswell, NM 0580',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1373,
    'parentId': 1434,
    'name': 'Albuquerque, NM 0922',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1706,
    'parentId': 1434,
    'name': 'Clarksville, TN 2493',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1384,
    'parentId': 1435,
    'name': 'Macedonia, OH 0962',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1386,
    'parentId': 1433,
    'name': 'Warr Acres, OK 0927',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25949,
    'parentId': 1434,
    'name': 'Oxnard, CA 2699',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 22277,
    'parentId': 1435,
    'name': 'Bradley, MI 0106',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 24146,
    'parentId': 1434,
    'name': 'Birmingham, AL 0726',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 28589,
    'parentId': 1433,
    'name': 'Golden Corral #109 Del City, OK',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 26276,
    'parentId': 1434,
    'name': 'Pembroke Pines, FL  0873',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 28831,
    'parentId': 1431,
    'name': 'Lake Charles 0110',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 26178,
    'parentId': 1435,
    'name': 'Holland, MI 0995  ',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 26357,
    'parentId': 1434,
    'name': 'Cedar City, UT   2704',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 27351,
    'parentId': 1434,
    'name': 'Puyallup, WA 2702',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1151,
    'parentId': 1214,
    'name': '1 - Bloomington, IN 0841 ',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1366,
    'parentId': 1214,
    'name': 'Fairfield, OH 0853',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1376,
    'parentId': 30408,
    'name': 'Oklahoma City, OK 0929',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1381,
    'parentId': 1689,
    'name': 'Springfield, OH 0953',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1214,
    'parentId': 1212,
    'name': 'Manager - Flannery',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1215,
    'parentId': 1212,
    'name': 'Manager Jackowiak',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1402,
    'parentId': 1214,
    'name': 'Covington / Ft. Wright, KY 0870',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1403,
    'parentId': 1689,
    'name': 'Columbus, OH 0769',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1163,
    'parentId': 1214,
    'name': 'Greenwood, IN 2412',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1358,
    'parentId': 29399,
    'name': 'Houston, TX 0625',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1399,
    'parentId': 1214,
    'name': 'Franklin, OH 0958',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1153,
    'parentId': 2133,
    'name': 'Cleveland, TN 0857',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1154,
    'parentId': 1214,
    'name': 'Indianapolis, IN 0878 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1166,
    'parentId': 1215,
    'name': 'MONTGOMERY, AL 2550',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1375,
    'parentId': 24994,
    'name': 'Grand Prairie, TX 0924',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1149,
    'parentId': 1215,
    'name': 'Opelika, AL 0776 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1150,
    'parentId': 1215,
    'name': 'Columbus, GA 0815',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1162,
    'parentId': 2133,
    'name': 'Louisville, KY 0967  ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1378,
    'parentId': 24839,
    'name': 'Independence, MO 0937',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1392,
    'parentId': 1689,
    'name': 'Grove City, OH 0972',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1400,
    'parentId': 1689,
    'name': 'Beavercreek, OH 0951',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1156,
    'parentId': 2133,
    'name': 'Louisville, KY 0899 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1367,
    'parentId': 30690,
    'name': 'Tallahassee, FL 0734',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1368,
    'parentId': 1689,
    'name': 'Cincinnati / Withamsville, OH 0874',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1369,
    'parentId': 1214,
    'name': 'Florence, KY 0887',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1152,
    'parentId': 1214,
    'name': 'Plainfield, IN 0846',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1689,
    'parentId': 1212,
    'name': 'Manager – Gebby',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 2133,
    'parentId': 1212,
    'name': 'Manager-Callinan',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 2125,
    'parentId': 25265,
    'name': 'Cullman, AL  0104',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23223,
    'parentId': 1214,
    'name': 'Anderson, IN 0975',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23535,
    'parentId': 23557,
    'name': 'Fayetteville, NC 989',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23539,
    'parentId': 23555,
    'name': 'Aberdeen, NC 583',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23553,
    'parentId': 29003,
    'name': 'SomeCorral, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23555,
    'parentId': 29003,
    'name': 'S & L Corral, Inc.',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23557,
    'parentId': 29003,
    'name': 'GC of Gayetteville, Inc.',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23537,
    'parentId': 23553,
    'name': 'Raleigh, NC 950',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23467,
    'parentId': 24811,
    'name': 'BRISTOL, VA 0689',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23692,
    'parentId': 30409,
    'name': 'MARANA, AZ 0932',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24055,
    'parentId': 24820,
    'name': 'EVANSVILLE, IN 0683',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24221,
    'parentId': 24827,
    'name': 'Augusta,GA 0933',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24205,
    'parentId': 24836,
    'name': 'McAllen,TX 0930',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24152,
    'parentId': 25265,
    'name': 'Hoover, AL 0743',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24449,
    'parentId': 25168,
    'name': 'Elyria, OH 0961',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24445,
    'parentId': 25167,
    'name': 'Dayton, OH 0957',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24447,
    'parentId': 25170,
    'name': 'Toledo, OH 0966',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24820,
    'parentId': 29003,
    'name': 'T.N.Y.Z. Corral, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24884,
    'parentId': 25375,
    'name': 'Harlingen, TX 994',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24817,
    'parentId': 29003,
    'name': 'SIBO, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24839,
    'parentId': 29003,
    'name': 'MAVS G LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24811,
    'parentId': 29003,
    'name': 'OK Corral, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24827,
    'parentId': 29003,
    'name': 'B. FEHR LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24836,
    'parentId': 29003,
    'name': 'JOHN GOMEZ ENTERPRISES LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25265,
    'parentId': 29003,
    'name': 'TA CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24977,
    'parentId': 25364,
    'name': 'Morristown, TN  0903',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24994,
    'parentId': 29003,
    'name': 'SAN-TEX 47 CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1045,
    'parentId': 23555,
    'name': 'Laurinburg, NC 0663',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 24981,
    'parentId': 25365,
    'name': 'Erie, PA, 0905',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25170,
    'parentId': 29003,
    'name': 'PUCKETTS CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25167,
    'parentId': 29003,
    'name': 'ANNETTES CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25168,
    'parentId': 29003,
    'name': 'MOLLYS CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25365,
    'parentId': 29003,
    'name': 'LAKE ERIE CORRAL LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1160,
    'parentId': 1215,
    'name': 'Hattiesburg, MS 0982 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25364,
    'parentId': 29003,
    'name': 'BABC OVERFELT LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 25375,
    'parentId': 29003,
    'name': 'LONE STAR CORRAL-SILVA LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 27359,
    'parentId': 30242,
    'name': 'Lake Placid - 0368',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1061,
    'parentId': 2133,
    'name': 'Louisville, KY 0952  ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1167,
    'parentId': 2133,
    'name': 'Knoxsville, TN 2428',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1383,
    'parentId': 1689,
    'name': 'Cincinnati, OH 0956',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1164,
    'parentId': 2133,
    'name': 'Chattanooga,TN 2442 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1155,
    'parentId': 2133,
    'name': 'Clarksville, IN 0959',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1372,
    'parentId': 30692,
    'name': 'Shreveport, LA 0918',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1382,
    'parentId': 1689,
    'name': 'Cincinnati, OH 0954',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1398,
    'parentId': 25167,
    'name': 'Richmond, IN 0960',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1350,
    'parentId': 24817,
    'name': 'College Station, TX 0540',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1390,
    'parentId': 29487,
    'name': 'Cleveland, OH 0965',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1165,
    'parentId': 1215,
    'name': 'Gulfport, MS 2582',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1364,
    'parentId': 1212,
    'name': 'Mobile, AL 0658',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 15250,
    'parentId': 25167,
    'name': 'Saginaw, MI 0105',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 23932,
    'parentId': 24817,
    'name': 'WACO, TX 0563',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1385,
    'parentId': 29399,
    'name': 'Keller, TX 0908',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 29399,
    'parentId': 29003,
    'name': 'Calco Restaurants, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 29251,
    'parentId': 29262,
    'name': 'GC-2712-JANESVILLE, WI',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 29262,
    'parentId': 29003,
    'name': 'Park Place Corral',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 29003,
    'parentId': 211,
    'name': 'GC Franchise',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 27292,
    'parentId': 25167,
    'name': 'Sandusky, OH 0108',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 29487,
    'parentId': 29003,
    'name': 'M.O.R Enterprise, Inc ',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30378,
    'parentId': 30637,
    'name': 'Manchester, NH 2717',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30408,
    'parentId': 29003,
    'name': 'C-MAX Hospitality, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30409,
    'parentId': 29003,
    'name': 'Desert Corral, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30690,
    'parentId': 29003,
    'name': 'GRUTA GROUP LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30692,
    'parentId': 29003,
    'name': 'GC of Shreveport LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30242,
    'parentId': 29003,
    'name': 'GCLP, inc',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 30637,
    'parentId': 29003,
    'name': 'HPL, LLC',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1522,
    'parentId': 1586,
    'name': 'Greensboro, NC 0859 ',
    'typeId': 5,
    'active': 0,
    'licenseMap': null
  },
  {
    'id': 1586,
    'parentId': 211,
    'name': 'GC Partners',
    'typeId': 4,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1523,
    'parentId': 1586,
    'name': 'Mount Airy, NC 0877',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1528,
    'parentId': 1586,
    'name': 'Columbia, SC 0812',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 13182,
    'parentId': 1586,
    'name': 'Greensboro, NC 0702',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 2086,
    'parentId': 1586,
    'name': 'Carbondale, IL 2456',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1525,
    'parentId': 1586,
    'name': 'Winston-Salem, NC 2474 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1526,
    'parentId': 1586,
    'name': 'Myrtle Beach, SC 2514',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1524,
    'parentId': 1586,
    'name': 'Myrtle Beach, SC 0854 ',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
  {
    'id': 1527,
    'parentId': 1586,
    'name': 'Myrtle Beach, SC 2451',
    'typeId': 5,
    'active': 1,
    'licenseMap': null
  },
];

export default hierarchy;